import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  addEducationTypeApi,
  getEducationTypeApi,
  updateEducationTypeApi,
} from "../../../Api/EducationType";

interface Props {
  url: string;
  editId?: string | null;
  onClose: () => void;
  onSaved?: () =>void;
}

export function EducationTypeForm({ url, editId, onClose , onSaved }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const id  =editId;

  const [EducationTypeName, setEducationTypeName] = useState("");
  const [isEdit, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [, setEtId] = useState<string>("");
  const [Id, setId] = useState("");

  useEffect(() => {
    const handleApiClick = async () => {
      try {
        if (id) {
          const educationTypeData: any = await getEducationTypeApi(url);
          const educationTypeToEdit = educationTypeData.find(
            (type: any) => type.id === id
          );
          if (educationTypeToEdit) {
            setId(educationTypeToEdit.id);
            setEducationTypeName(educationTypeToEdit.name);
            setIsEditMode(true);
            setLoading(false);
          }
        }
      } catch (error) {
        toast.error("Failed to fetch EducationType", { id: "fetchError" });
        setHasError(true);
        setLoading(false);
      }
    };
    handleApiClick();
  }, [id, navigate]);

  useEffect(() => {
    if (id) {
      setEtId(id);
      setIsEditMode(true);
      setLoading(true);
    } else {
      setIsEditMode(false);
      setLoading(false);
    }
  }, [id]);

  const handleResetForm = () => {
    setEducationTypeName("");
    onClose();
  };

  const handleSubmitClick = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!EducationTypeName) {
      toast.error("Please fill all the fields");
      return;
    }

    try {
      if (isEdit) {
        await updateEducationTypeApi(Id, EducationTypeName, url);
        toast.success("EducationType updated successfully");
      } else {
        await addEducationTypeApi(EducationTypeName, url);
        toast.success("Education Type Added Successfully");
      }
    
      navigate("/admin/EducationType");
        if(onSaved) onSaved();
      onClose();
    } catch (error) {
      toast.error(
        isEdit
          ? "Failed to update EducationType"
          : "Unable to add EducationType"
      );
    }

    setEducationTypeName("");
  };

  return (
    <div className="max-w-6xl">
      <div>
        {loading ? (
          <div className="flex justify-center items-center h-screen">
            <div
              className="flex justify-center items-center h-12 w-12 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] text-blue-600"
              role="status"
            >
              <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                Loading...
              </span>
            </div>
          </div>
        ) : hasError ? (
          <div className="flex justify-center items-center h-screen">
            {/* Blank page when there’s an error */}
          </div>
        ) : (
          <>
            <h2 className="text-3xl font-bold text-blue-600 mb-5">
              Education Type Form
            </h2>

            <form onSubmit={handleSubmitClick} className="mt-8 space-y-4">
              <div className="flex flex-col gap-4">
                <div>
                  <label
                    htmlFor="bankName"
                    className="block text-sm font-medium text-black dark:text-gray-200 mb-2"
                  >
                    Education Type
                  </label>
                  <input
                    id="Education Type"
                    type="text"
                    required
                    placeholder="Education Type"
                    value={EducationTypeName}
                    onChange={(event) =>
                      setEducationTypeName(event.target.value)
                    }
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              <div className="flex justify-start space-x-4">
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {isEdit ? "Update" : "Save and close"}
                </button>
                <button
                  type="button"
                  onClick={handleResetForm}
                  className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-gray-300"
                >
                  Cancel
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
